// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.-ErrorMessage-module-wrapper-pMf56{color:#ff977d}`, "",{"version":3,"sources":["webpack://./src/components/ErrorMessage/ErrorMessage.module.scss","webpack://./src/theme/_colors.scss"],"names":[],"mappings":"AAEA,oCACE,aCmDW","sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrapper": `-ErrorMessage-module-wrapper-pMf56`
};
export default ___CSS_LOADER_EXPORT___;
